"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListContent = void 0;
const React = require("react");
const mobx_react_1 = require("mobx-react");
const react_intl_1 = require("react-intl");
const reactstrap_1 = require("reactstrap");
const loader_1 = require("@festival/component/loader");
const classnames_1 = require("classnames");
class ListContent extends React.Component {
    render() {
        const { pageConfigurationStore, routeManager, className } = this.props;
        if (!pageConfigurationStore || !routeManager) {
            return null;
        }
        const becomeExponent = pageConfigurationStore.get('become_exponent');
        if (!becomeExponent) {
            return null;
        }
        if (!becomeExponent.complete) {
            return React.createElement(loader_1.default, null);
        }
        const becomeExponentComplete = becomeExponent;
        if (!becomeExponentComplete.details) {
            return null;
        }
        const mail = React.createElement("a", { href: `mailto:${becomeExponentComplete.details.managerMail}`, className: "mx-1" }, becomeExponentComplete.details.managerName);
        const phone = becomeExponentComplete.details.managerTel
            ? React.createElement("a", { href: `tel://${becomeExponentComplete.details.managerTel}`, className: "mx-1" },
                React.createElement("i", { className: "mdi mdi-phone mr-2" }),
                becomeExponentComplete.details.managerTel)
            : '';
        return (React.createElement(reactstrap_1.Card, { body: true, id: "become-exponent", className: classnames_1.default(className) },
            React.createElement(reactstrap_1.CardTitle, { tag: "h2" },
                React.createElement(react_intl_1.FormattedMessage, { id: "become-exponent.title" })),
            React.createElement(react_intl_1.FormattedMessage, { id: "become-exponent.subtitle" }),
            React.createElement("p", null,
                React.createElement(react_intl_1.FormattedMessage, { id: "become-exponent.manager", values: { mail: mail, phone: phone } })),
            becomeExponentComplete.details.commercialBrochureLink && (React.createElement("a", { href: becomeExponentComplete.details.commercialBrochureLink, target: "_blank", rel: "noreferrer", className: "btn btn-primary my-2" },
                React.createElement(react_intl_1.FormattedMessage, { id: "become-exponent.download.commercialBrochureLink" }))),
            becomeExponentComplete.details.applicationFormLink && (React.createElement("a", { href: becomeExponentComplete.details.applicationFormLink, target: "_blank", rel: "noreferrer", className: "btn btn-primary my-2" },
                React.createElement(react_intl_1.FormattedMessage, { id: "become-exponent.download.applicationFormLink" })))));
    }
}
exports.ListContent = ListContent;
exports.default = mobx_react_1.inject('pageConfigurationStore', 'routeManager')(mobx_react_1.observer(ListContent));
